import React, { useEffect, useState } from "react";
import ComboBox from "react-select";
import { FilePreview } from "cxa-components";
import { FileUploader } from "../common/file-uploader";
import { isEmpty } from "ramda";
import { getFileProps } from "cxa-utils";
import { FormField, StringField } from "cxa-form-field";
import { ACCEPT_FILES, MAX_FILE_SIZE } from "../constants";
import { renderRejectedFiles, resizeImage } from "./util";
import { change } from "redux-form";
import lodash from "lodash";

const renderReferralUploader = ({
  name,
  uploadedFiles,
  value,
  onChange,
  onBlur,
  onDrop,
  changeReferralFileName,
  meta,
  error,
  ...rest
}) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [rejectedFiles, setRejectedFiles] = useState([]);

  useEffect(() => {
    setSelectedFile(null);
    setRejectedFiles([]);
  }, []);

  // Rename referral filename
  // Parameters:
  //  - change - redux form action creator. form: string, fieldId: string, value: string
  const onSelectedFileChanged = value =>
    changeReferralFileName(change, {
      form: meta.form,
      fieldId: rest.renameFieldId,
      value,
    });

  const onDelete = () => {
    setSelectedFile(null);
    setRejectedFiles([]);
    onChange(null);
  };

  // reset selected file on load

  return (
    <div>
      {uploadedFiles && uploadedFiles.length && (
        <ComboBox
          options={uploadedFiles.map(file => ({
            label: file.value,
            value: file,
          }))}
          onChange={value => {
            setSelectedFile(value) ;
            setRejectedFiles([]) ;
            const data = lodash.get(value, "value", value);
            onChange(data);
            onSelectedFileChanged(data.value);
          }}
          value={selectedFile}
        />
      )}
      <FileUploader
        accept={ACCEPT_FILES}
        maxSize={MAX_FILE_SIZE}
        onDrop={(files, rejectedFiles) => {
          setSelectedFile(null);
          setRejectedFiles(rejectedFiles);
          if (rejectedFiles.length <= 0) {
            let selectedFile = (files && files.length && files[0]) || {};
            let fileList = [];
            resizeImage(selectedFile, fileList, fileList => {
              onChange(fileList[0] || {});
              const data = fileList.length ? fileList[0].name : "";
              onSelectedFileChanged(data);
            });
          } else {
            onSelectedFileChanged(null);
            onChange(null);
          }
        }}
        {...rest}
      />
      {!error && renderRejectedFiles(rejectedFiles)}
      {value && !isEmpty(value) && (
        <FilePreview className="u-margin-top" {...getFileProps(value)} onDelete={onDelete} />
      )}
      {value && !isEmpty(value) && (
        <StringField
          id={rest.renameFieldId}
          name={rest.renameFieldId}
          label={rest.renameFieldName}
        />
      )}
    </div>
  );
};

const ReferralField = props => {
  return <FormField multiple={false} component={renderReferralUploader} {...props} />;
};

export default ReferralField;



// WEBPACK FOOTER //
// ./components/claim/ReferralField.js